import * as React from 'react'
import axios from '../../services/index'
import { FaUserGraduate, FaTrashAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'

//This component show list of Users with key informations on them and the trainings they own
export const UserList: React.FunctionComponent = (props) => {

    interface IUsersArray {
        id: string,
        username: string,
        email: string,
        paidTraining: Array<any>
    }

    const [usersArray, setUsersArray] = React.useState<IUsersArray[]>([])
    const [trainingNameArray, setTrainingNameArray] = React.useState<Array<any>>([])
    const [usersListUpdate, setUsersListUpdate] = React.useState(false)
    const currentToken = localStorage.getItem('access_token')

    React.useEffect(() => {
        axios.get('https://LaurenceBrun.eu.pythonanywhere.com/training/', {
            headers: {
                "Authorization" : `Bearer ${currentToken}`
            }
        })
        .then(function(response: any) {
            let requestTrainingNameArray = response.data.map((training: any) => {
                return {
                    id: training.id,
                    title: training.title
                }
            })
            setTrainingNameArray(requestTrainingNameArray)
        })
        .catch(function(error: any) {
            console.log(error)
            alert("Une erreur est survenue ! Veuillez réessayer")
        })
    },[usersListUpdate])

    React.useEffect(() => {
        if(trainingNameArray.length > 0) {
            let arrayUsers: Array<any> = []
            axios.get('https://LaurenceBrun.eu.pythonanywhere.com/users/',{
                headers: {
                    "Authorization": `Bearer ${currentToken}`
                }
            })
            .then(function (response: any) {
                arrayUsers = response.data.map((user: any) => {
                    const User: IUsersArray = {
                        id: user.id,
                        username : user.username,
                        email : user.email,
                        paidTraining : user.paid_training.map((training: any) => {
                            return trainingNameArray.find((element: any) => element.id === training).title
                        }),
                    }
                    return User
                })          
            })
            .then(function() {
                setUsersArray(arrayUsers) 
            })
            .catch(function(error: any) {
                console.log(error);
                alert("Une erreur est survenue ! Veuillez réessayer")
            })
        }
    }, [trainingNameArray])

    const displayTraining = (trainingArray: any) => {
        return trainingArray.map((training: any) => {
            return (
                <div key={training}>{training}</div>
            )
        })
    }

    const deleteUser = (userId: number) => {
        if(window.confirm("Êtes-vous sur de vouloir supprimer cet utilisateur ?")) {
            axios.delete(`https://LaurenceBrun.eu.pythonanywhere.com/users/${userId}/`,{
                headers: {
                    "Authorization": `Bearer ${currentToken}`
                }
            })
            .then((response: any) => {
                alert('Suppression utilisateur réussie !')
                setUsersListUpdate(!usersListUpdate)
            })
            .catch((error: any) => {
                console.log(error)
                alert(`Cette erreur est survenue : ${error}`)
            })
        }
    }


    const tableRow = () => {
        return usersArray.map((user: any) => {
            if(user.paidTraining) {
                return (
                    <tr>
                        <td>{user.username}</td>
                        <td>{user.email}</td>
                        <td><ul>{displayTraining(user.paidTraining)}</ul></td>
                        <td ><Link to={{ pathname: `/admin/user/${user.id}/addTraining`, state: {trainingArray: trainingNameArray}}}><FaUserGraduate className="TdIcon" size={25}/></Link></td>
                        <td><FaTrashAlt className="TdIcon" size={25} onClick={()=> deleteUser(user.id)} /></td>
                    </tr>
                )}
        })
    }

    return(
        <div>
            <h2>Liste des utilisateurs</h2>
            <h3>Utilisateurs enregistrés : {usersArray.length}</h3>
            <table>
                <thead>
                    <tr>
                        <th>Nom d'utilisateur</th>
                        <th>Adresse Email</th>
                        <th>Liste des formations possédées</th>
                        <th>Offrir une formation</th>
                        <th>Supprimer utilisateur</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow()}
                </tbody>
            </table>
        </div>
    )
}